import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import stringMath from 'string-math';

import { safeWrap } from './functions';

const numericValue = (value) => {
  const parsedValue = parseInt(value, 0);
  return Number.isNaN(parsedValue) ? 0 : parsedValue;
};

const emptyFormData = {
  formData: {},
};

class WidgetTotal extends React.Component {
  state = {
    // @ts-expect-error
    value: this.props.value || 0,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { schema, formData } = nextProps;
    const { value } = this.state;

    const { fields = '', formula } = schema;
    let calculatedValue = fields.split(',').reduce((prev, cur) => prev + numericValue(formData[cur]), null);

    if (formula) {
      const formattedFormula = formula.replace('fieldsSum', calculatedValue);
      calculatedValue = stringMath(formattedFormula);
    }

    if (calculatedValue && calculatedValue !== value) {
      this.onChange(calculatedValue);
    }
  }

  onChange = (value) => {
    // @ts-expect-error
    const { onChange } = this.props;

    this.setState({ value });
    onChange(value);
  };

  render() {
    const { value } = this.state;

    return <div>Total: {value}</div>;
  }
}

// @ts-expect-error
WidgetTotal.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  schema: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  formContext: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const customFields = state.get('customFields');
  if (!customFields || !customFields.toJS) {
    return emptyFormData;
  }
  const formData = customFields.get(ownProps.formContext.form);
  if (!formData) {
    return emptyFormData;
  }
  return {
    formData,
  };
};
const mapDispatchToProps = () => ({});

// eslint-disable-next-line import/no-default-export
export default safeWrap(connect(mapStateToProps, mapDispatchToProps)(WidgetTotal));
